import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ICellRendererParams, IServerSideDatasource } from "ag-grid-community";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useNavigate } from "react-router-dom";
import { Autocomplete, Backdrop, Box, styled, TextField } from "@mui/material";
import { Dialog } from "primereact/dialog";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import * as React from "react";
import SpeedDial, { SpeedDialProps } from "@mui/material/SpeedDial";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import SaveIcon from "@mui/icons-material/Save";
import {
  CoppyNotice,
  GetLastNoticeRejectionReason,
  GetMyNotices,
  GetViewsId,
  RejectReson,
  SetUpDraft,
  UpdateNotice,
} from "../../../services/NoticeService";
import { toast } from "react-hot-toast";
import { to } from "@react-spring/web";
import {
  GetMyPosition,
  GetPositionRoleByPositionIdAndRole,
  GetUnderLayingPositions,
} from "../../../services/PositionService";
import { string } from "yup";
import { BaseGUrl, GURL } from "../../../services/global";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../../features/position/positionSlice";

import { CustomServerSideDatasource } from "../../../extentions/CustomServerSideDatasource";
import Table, { ColumnType, ColumnsType } from "antd/es/table";
import {
  Button,
  Checkbox,
  Col,
  Input,
  InputRef,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
  Tree,
} from "antd";
import {
  CopyOutlined,
  DeleteOutlined,
  RiseOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { FilterConfirmProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import ConvertToShamsi from "../../../extentions/convertors/ConvertToShamsi";
import CustomButton from "../../share/customButton";
import {
  GetAllCompanies,
  GetMyCompanyAcceleratorByNoticeId,
  SendAccelerator,
} from "../../../services/CompanyService";
import { GetInvitationsByCompanyName } from "../../../services/InvitationService";
import { DataNode } from "antd/es/tree";
import { ArrowDropDown } from "@mui/icons-material";
import { GetAllClasses } from "../../../services/ClassesService";
import { red } from "@mui/material/colors";
import { log } from "@grpc/grpc-js/build/src/logging";
var enterprise = require("@ag-grid-enterprise/core");
enterprise.LicenseManager.setLicenseKey(
  "DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6"
);
const Dashboard = () => {
  /////
  //senf
  const [getCategoryAutocomplete, setGetCategoryAutocomplete] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [ClassId, setClassId] = useState(null);
  const handleOptionChange = (event: any, option: any) => {
    if (option) {
      //console.log("optiond", option);
      setSelectedOption(option);
      setClassId(option.id);
    }
  };
  //end senf
  const [getDetails, setDetails] = useState();
  const [getViewsIdData, setViewsIdData] = useState<any>([]);
  const columnsDetails: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "2%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: "گیرنده",
      dataIndex: "name",
      key: "name",
      width: "10%",
      render: (item, record, index) => <>{record?.companyName}</>,
    },
    {
      title: "وضعیت",
      dataIndex: "name",
      key: "name",
      width: "10%",
      render: (item, record, index) => (
        <>
          {getViewsIdData.some(
            (data: any) => data.companyId === record?.reciverCompanyId
          ) ? (
            <>
              <Tag color="green">مشاهده شده</Tag>{" "}
            </>
          ) : (
            <Tag color="yellow">ارسال شده </Tag>
          )}
        </>
      ),
    },
    {
      title: "تاریخ  شتاب",
      dataIndex: "name",
      key: "name",
      width: "30%",
      render: (item, record, index) => <>{ConvertToShamsi(record?.sentDate)}</>,
    },
    {
      title: "تاریخ مشاهده",
      dataIndex: "name",
      key: "name",
      width: "30%",
      render: (item, record, index) => (
        <>
          {getViewsIdData.some(
            (data: any) => data.companyId === record?.reciverCompanyId
          ) ? (
            <>
              {ConvertToShamsi(
                getViewsIdData[
                  getViewsIdData.findIndex(
                    (data: any) => data.companyId === record?.reciverCompanyId
                  )
                ].dateTime
              )}
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];

  const compareValues = (a: any, b: any) => {
    // Handle different data types and null/undefined values
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    } else {
      return a - b;
    }
  };

  //Search and Filter Operations Start
  interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  }
  type DataIndex = keyof DataType;
  const [getAcceleratorModal, setAcceleratorModal] = useState(false);
  const [getAcceleratorDetailsModal, setAcceleratorDetailsModal] =
    useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex: any): ColumnType<any> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${"..."}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined rev={undefined} />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              handleSearch(selectedKeys as string[], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            پاک کردن
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            بستن
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined
        style={{ color: filtered ? "#1677ff" : undefined }}
        rev={undefined}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const [getSending, setSending] = useState(false);
  const [getNoticeTitle, setNoticeTitle] = useState("");
  const [
    getSelectedCompaniesToSendAccelerator,
    setSelectedCompaniesToSendAccelerator,
  ] = useState<string[]>();
  const handleCompanyChange = (value: string[]) => {
    console.log(`selected ${value}`);
    setSelectedCompaniesToSendAccelerator(value);
  };
  //tree start
  const [companyNameFilter, setCompanyNameFilter] = useState("");
  const [descriptionFilter, setDescriptionFilter] = useState("");

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);

  const onExpand = (expandedKeysValue: React.Key[]) => {
    console.log("onExpand", expandedKeysValue);
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.

    console.log(expandedKeysValue);
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };
  const onCheck = (checkedKeysValue: any): any => {
    const missingElements = checkedKeysValue.filter(
      (item: any) => !checkedKeys.includes(item)
    );
    setCheckedKeys((prevArrayB: any) => [...prevArrayB, ...missingElements]);
    console.log("onCheck-checkedKeysValue", checkedKeysValue);
    // setCheckedKeys(checkedKeysValue);

    return undefined;
  };

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    console.log("onSelect", info);
    //setSelectedKeys(selectedKeysValue);
  };
  const [treeData, setTreeData] = useState<DataNode[]>([]);
  const [treeDataFilter, setTreeDataFilter] = useState<DataNode[]>([]);

  //tree end
  //start new dashboard
  const [noticeData, setNoticeData] = useState();
  //end new dashboard

  //start new Dashboard Columns
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "2%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
      width: "20%",
      ...getColumnSearchProps("title"),
      sorter: (a, b) => compareValues(a.title, b.title),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "تاریخ",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "20%",
      ...getColumnSearchProps("createdDate"),
      sorter: (a, b) => compareValues(a.createdDate, b.createdDate),
      sortDirections: ["descend", "ascend"],
      render: (item, record, index) => (
        <>{ConvertToShamsi(record.createdDate)}</>
      ),
    },

    {
      title: "وضعیت",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "10%",
      ...getColumnSearchProps("noticeState"),
      sorter: (a, b) => compareValues(a.noticeState, b.noticeState),
      sortDirections: ["descend", "ascend"],
      render: (item, record, index) => (
        <>
          {record.noticeState === 1 ? <>پیش نویس</> : <> </>}
          {record.noticeState === 2 ? <>منتظر تایید</> : <> </>}
          {record.noticeState === 3 ? <> رد شده </> : <> </>}
          {record.noticeState === 5 ? <>منتشر شده</> : <> </>}
          {record.noticeState === 6 ? <>عدم انتشار</> : <> </>}
        </>
      ),
    },
    {
      title: "عملیات",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "25%",

      render: (item, record, index) => (
        <>
          <Tooltip title="کپی">
            <Popconfirm
              title="آیا از کپی این ردیف مطمئن هستید؟"
              okText="بله"
              cancelButtonProps={{
                className: "ant-btn-primary ant-btn-dangerous",
                style: {
                  backgroundColor: "white",
                },
              }}
              onCancel={(e) => e?.stopPropagation()}
              cancelText="خیر"
              onConfirm={(e) => {
                e?.stopPropagation();
                CoppyNotice(record.id).then(() => {
                  GetMyNotices(0).then((p) => {
                    setNoticeData(p.data);
                  });
                });
              }}
            >
              <a
                className="px-2"
                style={{ border: "1px" }}
                onClick={(event) => event.stopPropagation()}
              >
                <CopyOutlined />
              </a>
            </Popconfirm>
          </Tooltip>

          <Button
            className=" "
            style={{ width: "6rem" }}
            type="default"
            onClick={(event) => {
              event.stopPropagation();
              setAssigneVisible(true);
              setModalForNoticeId(record.id);
            }}
          >
            تخصیص
          </Button>
          {record.noticeState === 1 ? (
            <>
              {" "}
              <span style={{ paddingRight: "10px" }}>
                <Button
                  type="primary"
                  className="px-2"
                  style={{ width: "4rem" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    navigate(`/ManageNotice/${record.id}`);
                  }}
                >
                  ویرایش
                </Button>
              </span>
              <Tooltip title="حذف">
                <Popconfirm
                  title="آیا از حذف این ردیف مطمئن هستید؟"
                  okText="بله"
                  cancelButtonProps={{
                    className: "ant-btn-primary ant-btn-dangerous",
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  onCancel={(e) => e?.stopPropagation()}
                  cancelText="خیر"
                  onConfirm={(e) => {
                    e?.stopPropagation();
                    UpdateNotice({
                      noticeId: record.id,
                      key: "isdeleted",
                      value: "1",
                    }).then(() => {
                      GetMyNotices(0).then((p) => {
                        setNoticeData(p.data);
                      });
                    });
                  }}
                >
                  <a
                    className="px-2"
                    style={{ border: "1px" }}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <DeleteOutlined style={{ color: "red" }} />
                  </a>
                </Popconfirm>
              </Tooltip>
            </>
          ) : (
            <> </>
          )}
          {record.noticeState === 2 && ApproveAdvIn ? (
            <>
              <span className="px-2">
                <Button
                  type="primary"
                  className="px-2"
                  style={{ width: "4rem" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    SetShowModal(true);
                    setAcceptModalForNoticeId(record.id);
                  }}
                >
                  تایید
                </Button>
              </span>
              <span>
                <Button
                  type="primary"
                  className="px-2"
                  style={{
                    width: "4rem",
                    backgroundColor: "red",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setRejectionReason("");
                    setRejectVisible(true);
                    setRejectionModalForNoticeId(record.id);
                  }}
                >
                  رد
                </Button>
              </span>
              <span className="px-2">
                <Button
                  className=""
                  style={{ height: "2rem" }}
                  //color="info"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigate(`/ManageNotice/${record.id}`);
                  }}
                >
                  ویرایش
                </Button>
              </span>
            </>
          ) : (
            <> </>
          )}
          {record.noticeState === 5 ? (
            <>
              <Button
                className="mx-2"
                style={{ width: "6rem", backgroundColor: "lemonchiffon" }}
                onClick={(event) => {
                  event.stopPropagation();
                  SetunPublishedModal(true);
                  SetNoticeIdState(record.id);
                }}
              >
                عدم انتشار
              </Button>

              <Tooltip title="شتاب">
                <a
                  onClick={(event) => {
                    event.stopPropagation();
                    setAcceleratorModal(true);
                    setModalForNoticeId(record.id);
                    setNoticeTitle(record.title);
                  }}
                  className="px-2"
                  style={{ border: "1px" }}
                >
                  <RiseOutlined style={{ color: "green" }} />
                </a>
              </Tooltip>
            </>
          ) : (
            <> </>
          )}

          <Button
            className="px-2"
            color="default"
            style={{ height: "2rem" }}
            onClick={(event) => {
              event.stopPropagation();
              GetViewsId(record.id).then((p) => {
                console.log("dataaa", p);

                setViewsIdData(p.data.data);
              });
              GetMyCompanyAcceleratorByNoticeId(record.id).then((p) => {
                setDetails(p.data.data);
              });
              setModalForNoticeId(record.id);
              setAcceleratorDetailsModal(true);
            }}
          >
            جزئیات شتاب
          </Button>
        </>
      ),
    },
  ];
  //end new Dashboard Columns
  const [visible, setVisible] = useState(false);
  const [getAssigneVisible, setAssigneVisible] = useState(false);
  const [getRejectVisible, setRejectVisible] = useState(false);
  const [showModal, SetShowModal] = useState(false);
  const [GetunPublishedModal, SetunPublishedModal] = useState(false);
  const [GetNoticeIdState, SetNoticeIdState] = useState(null);

  const [getModalForNoticeId, setModalForNoticeId] = useState(null);
  const [getAcceptModalForNoticeId, setAcceptModalForNoticeId] = useState(null);

  const [modalNoticeId, setModalNoticeId] = useState("");
  const [getRejectionReason, setRejectionReason] = useState("");

  //start

  const [ApproveAdvIn, setApproveAdvIn] = useState(false);

  const dispatch = useDispatch<any>();
  const myPositions = useSelector(getMyPosition);

  async function GetPositionRoleByPositionIdAndRoleAsync3() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "ApproveAdv"
    ).then((p) => {
      setApproveAdvIn(p.data.data);
    });
  }
  useEffect(() => {
    //console.log(myPositions);

    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync3();
      }
    }
  }, [myPositions]);
  useEffect(() => {
    console.log("setApproveAdvInState", ApproveAdvIn);
  }, [ApproveAdvIn]);
  const [getCompanies, setCompanies] = useState([]);
  const [getCompaniesView, setCompaniesView] = useState([]);

  useEffect(() => {
    GetAllCompanies().then((p) => {
      const updatedData = p?.data?.data?.map((data: any) => ({
        title: data.name,
        key: data.id,
        phoneNumber: "0",
        classId: "0",
        description: "",
      }));
      console.log("setCompanies", updatedData);
      setCompanies(updatedData);
    });

    GetMyNotices(0).then((p) => {
      console.log("pdata", p.data);

      setNoticeData(p.data);
    });
    dispatch(fetchUserPosition());
    GetUnderLayingPositions().then((d) => console.log(d));

    GetAllClasses().then((p) => {
      const transformedData = p.data.data.map((item: any) => ({
        id: item.id,
        label: item.name,
      }));

      setGetCategoryAutocomplete(transformedData);
    });
    //console.log("loggedInProfileFromAccount", loggedInProfile.loggedInProfile);
  }, []);
  useEffect(() => {
    if (getCompanies.length > 1) {
      GetInvitationsByCompanyName("dd").then((p) => {
        const updatedData2 = p?.data?.data?.map((data: any) => ({
          title: data.companyName,
          key: data.id,
          phoneNumber: data.phoneNumber,
          classId: data.classId,
          description: data.description,
        })) as [];
        console.log("ssss", getCompanies);
        setTreeData((perv) => [...getCompanies, ...updatedData2]);
        // setCompaniesView((perv) => [...getCompanies, ...updatedData2]);
      });
    }
  }, [getCompanies]);

  const filterOption = (input: any, option: any) => {
    return option.label.toLowerCase().includes(input.toLowerCase());
  };

  function refreshData() {
    GetMyNotices(0).then((p) => {
      // console.log("setNoticeData", p.data);
      setNoticeData(p.data);
    });
  }
  //end

  const [getRejectionModalForNoticeId, setRejectionModalForNoticeId] =
    useState(null);

  const onGridReadyMain = (params: any) => {
    gridApiMain.current = params.api;
  };
  const gridApiMain = useRef(null);

  const onFirstDataRenderedMain = () => {
    if (gridApiMain.current) {
      (gridApiMain.current as any).sizeColumnsToFit();
    }
  };

  const GetLastRejectionResonAsync = async (noticeId: any) => {
    return await GetLastNoticeRejectionReason(noticeId).then((p) => {
      console.log("reject reson", p);

      return p?.data?.data?.reason;
    });
  };

  const StatusRenderer: React.FC<ICellRendererParams> = (params: any) => {
    const [cellReasonValue, setCellReasonValue] = useState("");

    const id = params.data.Id;

    const status = params.data.Status;
    if (status === 3) {
      GetLastRejectionResonAsync(id).then((p) => setCellReasonValue(p));
    }
    const cellValue = status; //valueFormatted ? valueFormatted : value;

    return (
      <span>
        {cellValue == 1
          ? "پیش نویس"
          : cellValue == 2
          ? "منتظر تایید"
          : cellValue == 3
          ? " رد شده" + " (" + cellReasonValue + ") "
          : cellValue == 5
          ? "منتشر شده"
          : cellValue == 6
          ? "عدم انتشار"
          : cellValue}
      </span>
    );
  };

  //
  const CustomCellRenderer: React.FC<ICellRendererParams> = (params: any) => {
    //console.log(params);
    console.log("ApproveAdvInBt", ApproveAdvIn);

    const id = params.data.Id;
    const status = params.data.Status;

    // Use both id and status to render the cell content
    const cellContent = `ID: ${id}, Status: ${status}`;
    const buttonClicked = useCallback(() => {
      alert(`${id}   won!`);
    }, []);
    // Return the content to be displayed in the cell

    return (
      <>
        {status === 2 ? (
          ApproveAdvIn === true ? (
            <>
              <span className="px-2">
                <Button
                  className="px-2"
                  color="primary"
                  style={{ height: "2rem" }}
                  onClick={() => {
                    SetShowModal(true);
                    setAcceptModalForNoticeId(id);
                  }}
                >
                  تایید
                </Button>
              </span>
              <span>
                <Button
                  className="px-2"
                  style={{ height: "2rem" }}
                  color="danger"
                  onClick={() => {
                    setRejectionReason("");
                    setRejectVisible(true);
                    setRejectionModalForNoticeId(id);
                  }}
                >
                  رد
                </Button>
              </span>

              <span className="px-2">
                <Button
                  className=""
                  style={{ height: "2rem" }}
                  color="primary"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigate(`/ManageNotice/${id}`);
                  }}
                >
                  ویرایش
                </Button>
              </span>
            </>
          ) : (
            <> </>
          )
        ) : (
          <></>
        )}
        <span className="">
          <Button
            className=" "
            style={{ height: "2rem" }}
            color="default"
            onClick={() => {
              setAssigneVisible(true);
              setModalForNoticeId(id);
            }}
          >
            تخصیص
          </Button>

          {status === 5 ? (
            <>
              <span className="px-2">
                <Button
                  className="px-2"
                  color="default"
                  style={{ height: "2rem" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    SetunPublishedModal(true);
                    SetNoticeIdState(id);
                  }}
                >
                  عدم انتشار
                </Button>
              </span>
            </>
          ) : (
            <></>
          )}
        </span>
      </>
    );
  };

  const CellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    const cellValue = valueFormatted ? valueFormatted : value;

    const buttonClicked = useCallback(() => {
      //alert(`${cellValue} medals won!`);
      setModalNoticeId(value);
      setVisible(true);
    }, []);
    return (
      <span>
        {/* <span>{cellValue}</span>&nbsp; */}
        <Button onClick={buttonClicked}>مشاهده</Button>
      </span>
    );
  };
  const ModalUserCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(
        `${GURL}/Authentication/v1/UserProfile/GetUserProfileById?Id=${value}`
      )
      .then((response) => {
        //00console.log("RER");
        //console.log(response.data.data.firstName);

        setCellValue(
          response.data.data.firstName + " " + response.data.data.lastName
        ); // ;
        console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };
  const ModalActionTypeCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;

    return <span>{value === 0 ? "تغییر کاربر مسئول" : "ویرایش آگهی"}</span>;
  };

  ModuleRegistry.registerModules([ServerSideRowModelModule]);

  const assigneeModalColumns = [
    {
      field: "name",
      headerName: "سمت",
      hide: false,
      sortable: true,
      filter: true,

      // cellRenderer: ModalActionTypeCellRenderer,
    },
    {
      field: "id",
      hide: true,
      filter: true,
    },
  ];

  const modalColumns = [
    {
      field: "actionType",
      headerName: "عملیات",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalActionTypeCellRenderer,
    },
    {
      field: "actionOwnerUserId",
      headerName: "کاربر مبدا",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalUserCellRenderer,
    },
    {
      field: "actionTargetUserId",
      headerName: "کاربر مقصد",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalUserCellRenderer,
    },
    {
      field: "oldDescription",
      headerName: "توضیحات قبلی",
      hide: false,
      sortable: true,
      filter: true,
    },
    {
      field: "newDescription",
      headerName: "توضیحات جدید",
      hide: false,
      sortable: true,
      filter: true,
    },
  ];

  const columns = useMemo(
    () => [
      {
        field: "Id",
        hide: true,
        filter: true,
      },
      {
        field: "Title",
        headerName: "عنوان",
        filter: true,
      },
      {
        field: "NoticeType",
        headerName: "نوع",
        filter: true,
        width: 100,
      },
      {
        field: "Status",
        headerName: "وضعیت",
        cellRenderer: StatusRenderer,
        filter: true,
        width: 100,
      },
      {
        field: "CreatedUser",
        headerName: "ثبت شده توسط",
        filter: true,
        hide: true,
      },

      {
        field: "Id",
        headerName: " عملیات ",
        cellRenderer: CustomCellRenderer,
        filter: false,
        sortable: false,
        autoSize: true, // Auto-size this column
      },
      {
        field: "Id",
        headerName: " تاریخچه ",
        cellRenderer: CellRenderer,
        filter: false,
        sortable: false,
        width: 100,
      },
    ],
    []
  );

  class MyAssigneModalServerSideDatasource {
    getRows(params: any) {
      // Make API call to fetch data from server
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;
      axios
        .get(`${GURL}/company/v1/position`)
        .then((response) => {
          console.log(response.data);

          // Return data to Ag Grid
          params.successCallback(response.data, -1);
        })
        .catch((error) => {
          console.error(error);
          // Return error to Ag Grid
          params.failCallback();
        });
    }
  }
  class MyModalServerSideDatasource {
    getRows(params: any) {
      // Make API call to fetch data from server

      axios
        .get(
          `${GURL}/Notice/v1/NoticeLogs/GetById/${modalNoticeId}?Id=${modalNoticeId}`
        )
        .then((response) => {
          console.log(response);

          // Return data to Ag Grid
          params.successCallback(response.data.data, -1);
        })
        .catch((error) => {
          console.error(error);
          // Return error to Ag Grid
          params.failCallback();
        });
    }
  }

  const refreshMainGridData = () => {
    refreshData();
  };

  const columnDefs = [
    // Define your column definitions here
    // ...
  ];

  const navigate = useNavigate();

  const assigneeGridOptions = {
    onCellDoubleClicked: async function (event: any) {
      const { data } = event;
      // console.log(data.id);
      if (getModalForNoticeId) {
        await UpdateNotice({
          noticeId: getModalForNoticeId,
          key: "responsiblepositionid",
          value: data.id,
        }).then(() => {
          setModalForNoticeId(null);
          setAssigneVisible(false);
          toast.success("با موفقیت تخصیص داده شد");
          refreshMainGridData();
        });
      }

      // Handle double-click event here
    },
    enableRtl: true,

    // ... other grid options ...
    localeText: {
      // ... custom translations ...
      notContains: "شامل نشود",
      contains: "شامل شود",
      equals: "برابر باشد با",
      notEqual: "برابر نباشد با",
      startsWith: "شروع شود با",
      endsWith: "پایان یابد با",
      notBlank: "خالی نباشد",
      blank: "خالی باشد",
      loadingOoo: "در حال بارگزاری لطفا منتظر بمانید",
      andCondition: "و",
      orCondition: "یا",
      loadingError: "متاسفانه خطایی در سرور رخ داده است !",
      pageNotFound: "صفحه مورد نظر یافت نشد",
      noRowsToShow: " رکوردی موجود نیست ",
      filterOoo: "فیلتر . . .",
    },
  };
  const gridOptions = {
    statusBar: {
      statusPanels: [
        {
          statusPanel: "agTotalRowCountComponent",
          align: "left",
          key: "totalRows",
          // Customize the label text
          // The following label text is just an example, you can customize it as needed
          label: "Total Rows: ",
        },
      ],
    },
    onCellDoubleClicked: function (event: any) {
      const { data } = event;
      console.log("Cell double-clicked:", data);
      navigate(`/notice/${data.Id}`);
      // Handle double-click event here
    },
    enableRtl: true,

    // ... other grid options ...
    localeText: {
      // ... custom translations ...
      notContains: "شامل نشود",
      contains: "شامل شود",
      equals: "برابر باشد با",
      notEqual: "برابر نباشد با",
      startsWith: "شروع شود با",
      endsWith: "پایان یابد با",
      notBlank: "خالی نباشد",
      blank: "خالی باشد",
      loadingOoo: "در حال بارگزاری لطفا منتظر بمانید",
      andCondition: "و",
      orCondition: "یا",
      loadingError: "متاسفانه خطایی در سرور رخ داده است !",
      pageNotFound: "صفحه مورد نظر یافت نشد",
      noRowsToShow: " رکوردی موجود نیست ",
      filterOoo: "فیلتر . . .",
    },
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onGridReady = (params: any) => {
    gridApi.current = params.api;
  };
  const gridApi = useRef(null);

  const onFirstDataRendered = () => {
    if (gridApi.current) {
      (gridApi.current as any).sizeColumnsToFit();
    }
  };

  const MyGrid = useMemo(
    () =>
      React.memo(() => (
        <AgGridReact
          serverSideDatasource={
            new CustomServerSideDatasource(
              `${BaseGUrl}/odata`,
              "Customers",
              columns,
              "GetCustomersCount"
            )
            //new MyServerSideDatasource()
          }
          rowModelType="serverSide"
          cacheBlockSize={5}
          gridOptions={gridOptions}
          columnDefs={columns}
          onFirstDataRendered={onFirstDataRenderedMain}
          onGridReady={onGridReadyMain}
          defaultColDef={{
            sortable: true,
            resizable: true,
            filter: true,
          }}
        ></AgGridReact>
      )),
    [columns]
  );

  return (
    <div dir="rtl" className="mt-2" style={{ width: "100%", height: 500 }}>
      {/* <MyGrid /> */}

      <Table
        size="small"
        scroll={{ y: 460 }}
        dataSource={noticeData}
        pagination={false}
        columns={columnsTotal}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              navigate(`/notice/${record.id}`);
            }, // click row
          };
        }}
      />

      <Modal
        open={getAcceleratorDetailsModal}
        footer={null}
        width={"80%"}
        onCancel={() => setAcceleratorDetailsModal(false)}
      >
        <div>
          <Table
            style={{ width: "100%" }}
            columns={columnsDetails}
            className="mt-2"
            size="small"
            dataSource={getDetails}
            pagination={false}
          />
        </div>
      </Modal>

      <Modal
        title="شتاب دهنده"
        footer={null}
        open={getAcceleratorModal}
        width={"50%"}
        onCancel={() => {
          setSelectedCompaniesToSendAccelerator([]);
          setNoticeTitle("");
          setAcceleratorModal(false);
        }}
      >
        <Row>
          <Col style={{ width: "70%" }}>
            <p>لطفا نوع شتاب را انتخاب کنید </p>
            <Checkbox checked>پیامک</Checkbox>

            <Checkbox>اعلان درون سیستمی</Checkbox>
            <div className="d-flex my-3">
              <Input
                onChange={(e) => setDescriptionFilter(e.target.value)}
                placeholder="توضیحات"
              />
              <Button
                onClick={() => {
                  setTreeDataFilter(
                    treeData.filter((record: any) =>
                      record.description?.includes(descriptionFilter)
                    )
                  );
                }}
                className="mx-2"
              >
                جستجو
              </Button>
              <Button onClick={() => setTreeDataFilter([])}>
                پاک کردن فیلتر
              </Button>
            </div>
            <div className="d-flex my-3">
              <Input
                onChange={(e) => setCompanyNameFilter(e.target.value)}
                placeholder="نام فروشگاه"
              />
              <Button
                onClick={() => {
                  console.log(companyNameFilter);

                  console.log(
                    treeData.filter((record: any) =>
                      record.title.includes(companyNameFilter)
                    )
                  );
                  setTreeDataFilter(
                    treeData.filter((record: any) =>
                      record.title.includes(companyNameFilter)
                    )
                  );
                }}
                className="mx-2"
              >
                جستجو
              </Button>
              <Button onClick={() => setTreeDataFilter([])}>
                پاک کردن فیلتر
              </Button>
            </div>
            <Row style={{ marginTop: "20px" }}>
              <h6 className="mb-2">صنف فعالیت تامین کننده</h6>
            </Row>
            <Row className="my-2">
              <Autocomplete
                style={{ width: "100%" }}
                sx={{
                  "& label": {
                    left: "unset",
                    right: "1.75rem",
                    transformOrigin: "right",
                    fontSize: "1rem",
                  },
                  "& legend": {
                    textAlign: "right",
                    fontSize: "1rem",
                  },
                  paddingRight: "0px",
                }}
                dir="rtl"
                disablePortal
                id="combo-box-demo"
                options={getCategoryAutocomplete}
                value={selectedOption}
                onChange={handleOptionChange}
                getOptionLabel={(option: any) => option.label}
                renderInput={(params) => (
                  <TextField
                    sx={{ paddingRight: "0px" }}
                    {...params}
                    label="صنف تامین کننده"
                  />
                )}
                popupIcon={
                  <ArrowDropDown
                    style={{
                      position: "relative",
                      float: "left",
                    }}
                  />
                }
              />
              <Button
                onClick={() => {
                  console.log("treeData", treeData);
                  console.log("classId", ClassId);

                  setTreeDataFilter(
                    treeData.filter((record: any) => record.classId === ClassId)
                  );
                }}
                className="mx-2"
              >
                جستجو
              </Button>
              <Button onClick={() => setTreeDataFilter([])}>
                پاک کردن فیلتر
              </Button>
            </Row>
            <p>
              لطفا فروشگاه هایی که میخواهید برای آنها شتاب ارسال کنید را انتخاب
              کنید
            </p>
            <Tree
              className="iran"
              checkable
              onExpand={onExpand}
              expandedKeys={expandedKeys}
              autoExpandParent={autoExpandParent}
              onCheck={onCheck}
              checkedKeys={checkedKeys}
              onSelect={onSelect}
              selectedKeys={selectedKeys}
              treeData={treeDataFilter.length === 0 ? treeData : treeDataFilter}
            />
          </Col>
          <Col>
            <div className="mx-2">
              <p>فروشگاه های انتخاب شده</p>
              {checkedKeys.map((f) => {
                return (
                  <div style={{ backgroundColor: "transparent" }}>
                    <span>
                      {treeData.filter((p) => p.key === f)[0]?.title as String}
                      <DeleteOutlined
                        onClick={() => {
                          setCheckedKeys(
                            checkedKeys.filter(
                              (item: any) =>
                                item !==
                                treeData
                                  .filter((p) => p.key === f)[0]
                                  .key.toString()
                            )
                          );
                        }}
                        style={{
                          color: "red",
                          left: "0",
                          position: "absolute",
                        }}
                      />
                    </span>
                  </div>
                );
              })}
            </div>
            <CustomButton
              disabled={getSending}
              className="m-2"
              hasTitle
              customType="Primary"
              onClick={() => {
                setSending(true);
                SendAccelerator({
                  ids: checkedKeys,
                  title: getNoticeTitle,
                  noticeId: getModalForNoticeId,
                }).then(() => {
                  setCheckedKeys([]);
                  setNoticeTitle("");
                  setAcceleratorModal(false);
                  setSending(false);
                });
              }}
            >
              ارسال
            </CustomButton>
          </Col>
        </Row>
      </Modal>

      <Dialog
        visible={visible}
        modal={false}
        style={{ width: "75vw" }}
        onHide={() => setVisible(false)}
      >
        <div
          dir="rtl"
          className="mt-2 ag-theme-alpine"
          style={{ width: "100%", height: 200 }}
        >
          <AgGridReact
            columnDefs={modalColumns}
            rowModelType={"serverSide"}
            gridOptions={gridOptions}
            serverSideDatasource={new MyModalServerSideDatasource()}
          />
        </div>
      </Dialog>
      <Dialog
        visible={getAssigneVisible}
        modal={false}
        style={{ width: "75vw" }}
        onHide={() => setAssigneVisible(false)}
      >
        <div
          dir="rtl"
          className="mt-2 ag-theme-alpine"
          style={{ width: "100%", height: 200 }}
        >
          <AgGridReact
            columnDefs={assigneeModalColumns}
            rowModelType={"serverSide"}
            gridOptions={assigneeGridOptions}
            onFirstDataRendered={onFirstDataRendered}
            onGridReady={onGridReady}
            serverSideDatasource={new MyAssigneModalServerSideDatasource()}
          />
        </div>
      </Dialog>
      <Dialog
        visible={getRejectVisible}
        modal={false}
        style={{ width: "75vw" }}
        onHide={() => setRejectVisible(false)}
      >
        <div
          dir="rtl"
          className="mt-2 ag-theme-alpine"
          style={{ width: "100%" }}
        >
          <TextField
            name="description"
            style={{ width: "100%", height: 85 }}
            placeholder={"دلیل رد آگهی"}
            rows={7}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
          <span>
            <Button
              className="px-2"
              style={{ height: "2rem" }}
              color="danger"
              //onClick={buttonClicked}
              onClick={async () => {
                console.log(getRejectionReason);
                if (getRejectionReason === "") {
                  toast.error("لطفا دلیل رد اگهی را بنویسید");
                  return;
                }
                await RejectReson({
                  noticeId: getRejectionModalForNoticeId,
                  reason: getRejectionReason,
                });
                await UpdateNotice({
                  key: "noticestate",
                  value: "3",
                  noticeId: getRejectionModalForNoticeId,
                })
                  .then(() => toast.error("آگهی رد شد"))
                  .then(() => setRejectVisible(false))
                  .then(() => refreshMainGridData());
              }}
            >
              رد کردن
            </Button>
            <span className="px-2">
              <Button
                className="px-2"
                style={{ height: "2rem" }}
                color="primary"
                onClick={() => {
                  setRejectionReason("");
                  setRejectVisible(false);
                }}
              >
                انصراف
              </Button>
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog
        id="test"
        style={{ width: "50vw", display: "inline-flex" }}
        visible={GetunPublishedModal}
        onHide={() => SetunPublishedModal(false)}
      >
        <h3>آیا مایل به عدم انتشار آگهی هستید ؟</h3>
        <div style={{ backgroundColor: "transparent", textAlign: "center" }}>
          <Button
            className="px-2 mx-2"
            style={{ height: "2rem" }}
            color="primary"
            onClick={async (e) =>
              await UpdateNotice({
                key: "noticestate",
                value: "6",
                noticeId: GetNoticeIdState,
              })
                .then(() => toast.success("آگهی از لیست انتشار خارج شد"))
                .then(() => SetunPublishedModal(false))
                .then(() => {
                  refreshMainGridData();
                  window.location.reload();
                })
            }
          >
            بله
          </Button>
          <Button
            className="px-2"
            style={{ height: "2rem" }}
            color="danger"
            onClick={() => {
              SetShowModal(false);
            }}
          >
            انصراف
          </Button>
        </div>
      </Dialog>
      <Dialog
        id="test"
        style={{ width: "50vw", display: "inline-flex" }}
        visible={showModal}
        onHide={() => SetShowModal(false)}
      >
        <h3>آیا مایل به تایید آگهی هستید ؟</h3>
        <div style={{ backgroundColor: "transparent", textAlign: "center" }}>
          <Button
            className="px-2 mx-2"
            style={{ height: "2rem" }}
            color="primary"
            onClick={async (e) =>
              await UpdateNotice({
                key: "noticestate",
                value: "5",
                noticeId: getAcceptModalForNoticeId,
              })
                .then(() => toast.success("آگهی تایید شد"))
                .then(() => SetShowModal(false))
                .then(() => {
                  refreshMainGridData();
                  window.location.reload();
                })
            }
          >
            بله
          </Button>
          <Button
            className="px-2"
            style={{ height: "2rem" }}
            color="danger"
            onClick={() => {
              SetShowModal(false);
            }}
          >
            انصراف
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Dashboard;
